import React, { useState, useEffect } from 'react';
import CustomDropdown from './CustomDropdown/CustomDropdown';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import * as ClaimActions from "../../../../store/action/claim";
import { getAllCauses } from '../../../../store/action/cause';
import { getAllForms } from '../../../../store/action/form';
import { filterUsersByGroupLabel } from "../../../../store/action/user";

const useStyles = makeStyles((theme) => ({
    container: {
        padding: "40px",
    },
    header: {
        marginBottom: "20px",
    },
    labelInput: {
        fontFamily: "Poppins",
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "18px",
        textAlign: "left",
        color: "rgba(70, 78, 95, 1)",
        marginBottom: '10px'
    },
    styleInput: {
        borderRadius: "4px",
        border: 0,
        background: "rgba(243, 246, 249, 1)",
        height: "36px",
        width: "100%",
        padding: "10px",
        fontFamily: "Poppins",
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "18px",
        textAlign: "left",
        color: "rgba(70, 78, 95, 1)",
    },
    formRow: {
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: '15px',
        gap: '20px',
    },
    formGroup: {
        flex: '1 1 calc(50% - 20px)',
        minWidth: '250px',
    },
    buttonContainer: {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: '20px',
    },
    selectStyle: {
        width: "100%",
        height: "36px",
        borderRadius: "4px",
        border: 0,
        background: "rgba(243, 246, 249, 1)",
        padding: "10px",
        fontFamily: "Poppins",
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "18px",
        textAlign: "left",
        color: "rgba(70, 78, 95, 1)",
    },
    textAreaStyle: {
        width: "100%",
        height: "100px",
        borderRadius: "4px",
        border: 0,
        background: "rgba(243, 246, 249, 1)",
        padding: "10px",
        fontFamily: "Poppins",
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "18px",
        textAlign: "left",
        color: "rgba(70, 78, 95, 1)",
    },
    annulerStyle: {
        width: '83px',
        height: '36px',
        borderRadius: '5px',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '20px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
        backgroundColor: 'rgba(229, 234, 238, 1)',
        color: 'rgba(128, 128, 143, 1)',
        marginRight: '20px'
    },
    validerStyle: {
        width: '83px',
        height: '36px',
        borderRadius: '5px',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '20px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
        backgroundColor: 'rgba(86, 157, 210, 1)',
        color: 'rgba(255, 255, 255, 1)',
        marginRight: '40px'
    },
}));

const DetailsTab = ({
    claimNumber,
    onClaimNumberChange,
    handleNext,
    formData,
    handleFormChange,
    handleDropdownChange,
    readOnly
}) => {
    const classes = useStyles();
    const [selectedClaim, setSelectedClaim] = useState(claimNumber || '');
    const dispatch = useDispatch();
    const { claimData } = useSelector((state) => state.claimReducer) || { claimData: [] }; // Ensure default value
    const { causes } = useSelector((state) => state.causeReducer);
    const { forms } = useSelector((state) => state.formReducer);
    const [groupLabel, setGroupLabel] = useState('BOSTAR');
    const [filteredUsers, setFilteredUsers] = useState([]);
    const today = new Date().toISOString().split('T')[0];

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch claims if not already loaded
                if (!claimData || claimData.length === 0) {
                    await dispatch(ClaimActions.getAllClaims());
                }
    
                // Fetch causes if not already loaded or set default to empty
                // if (!causes || causes.length === 0) {
                //     const fetchedCauses = await dispatch(getAllCauses());
                //     if (!fetchedCauses || fetchedCauses.length === 0) {
                //         console.warn('No causes found. Setting to empty.');
                //     }
                // }
    
                // // Fetch forms if not already loaded or set default to empty
                // if (!forms || forms.length === 0) {
                //     const fetchedForms = await dispatch(getAllForms());
                //     if (!fetchedForms || fetchedForms.length === 0) {
                //         console.warn('No forms found. Setting to empty.');
                //     }
                // }
    
                // Fetch and filter users by group label if not already filtered
                if (filteredUsers.length === 0) {
                    const users = await dispatch(filterUsersByGroupLabel(groupLabel));
                    setFilteredUsers(users || []);
                }
    
                // Handle claim-specific data
                if (claimNumber && Array.isArray(claimData)) {
                    const selectedClaimObj = claimData.find((claim) => claim.claimNumber === claimNumber);
                    if (selectedClaimObj) {
                        onClaimNumberChange({ ...selectedClaimObj });
                        handleFormChange({
                            target: {
                                name: 'damageType',
                                value: selectedClaimObj.damageType,
                            },
                        });
                    }
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
    
        fetchData();
    }, [dispatch, groupLabel, claimNumber, claimData, causes, forms, filteredUsers.length, onClaimNumberChange, handleFormChange]);
    
    const causesOptions = causes?.map((cause) => ({
        id: cause._id,
        name: cause.name,
    }));
    const formsOptions = forms?.map((form) => ({
        id: form._id,
        name: form.formName,
    }));

    return (
        <div className={classes.container}>
            <div className={classes.formRow}>
                <div className={classes.formGroup}>
                    <label className={classes.labelInput} htmlFor="title">Titre</label>
                    <input
                        type="text"
                        id="title"
                        name="title"
                        value={formData.title}
                        onChange={handleFormChange}
                        className={classes.styleInput}
                        disabled={readOnly}
                    />
                </div>
                <div className={classes.formGroup}>
                    <label className={classes.labelInput} htmlFor="claimSelect">N° Sinistre</label>
                    <input
                        type="text"
                        id="claimSelect"
                        name="claimSelect"
                        value={claimNumber}
                        className={classes.selectStyle}
                        disabled
                    />
                </div>
            </div>
            <div className={classes.formRow}>
                <div className={classes.formGroup}>
                    <label className={classes.labelInput} htmlFor="description">Description</label>
                    <textarea
                        id="description"
                        name="description"
                        value={formData.description}
                        onChange={handleFormChange}
                        className={classes.textAreaStyle}
                        disabled={readOnly}
                    ></textarea>
                </div>
            </div>
            <div className={classes.formRow}>
                <div className={classes.formGroup}>
                    <label className={classes.labelInput} htmlFor="responsable">Utilisateur Responsable</label>
                    <select
                        id="responsable"
                        name="responsable"
                        value={formData.responsable}
                        onChange={handleFormChange}
                        className={classes.styleInput}
                        disabled={readOnly}
                    >
                        <option value="">Choisir un utilisateur</option>
                        {filteredUsers?.map((user) => (
                            <option key={user._id} value={user._id}>
                                {user.firstName}
                            </option>
                        ))}
                    </select>
                </div>
                <div className={classes.formGroup}>
                    <label className={classes.labelInput} htmlFor="assigne">Utilisateur Assigné</label>
                    <select
                        id="assigne"
                        name="assigne"
                        value={formData.assigne}
                        onChange={handleFormChange}
                        className={classes.styleInput}
                        disabled={readOnly}
                    >
                        <option value="">Choisir un utilisateur</option>
                        {filteredUsers?.map((user) => (
                            <option key={user._id} value={user._id}>
                                {user.firstName}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className={classes.formRow}>
                <div className={classes.formGroup}>
                    <label className={classes.labelInput} htmlFor="status">État</label>
                    <select
                        id="status"
                        name="status"
                        value={formData.status}
                        onChange={handleFormChange}
                        className={classes.selectStyle}
                    >
                        <option value="">Sélectionner</option>
                        <option value="Not Started">Pas commencé</option>
                        <option value="In Progress">En cours</option>
                        <option value="Completed">Terminé</option>
                    </select>
                </div>
                <div className={classes.formGroup}>
                    <label className={classes.labelInput} htmlFor="priority">Priorité</label>
                    <select
                        id="priority"
                        name="priority"
                        value={formData.priority}
                        onChange={handleFormChange}
                        className={classes.selectStyle}
                    >
                        <option value="">Sélectionner</option>
                        <option value="Low">Faible</option>
                        <option value="Medium">Moyenne</option>
                        <option value="High">Élevée</option>
                    </select>
                </div>
            </div>

            <div className={classes.formRow}>
                <div className={classes.formGroup}>
                    <div className={classes.labelInput}>
                        <CustomDropdown
                            label="Causes Associées"
                            options={causesOptions}
                            selectedOptions={formData.causesAssociees}
                            setSelectedOptions={(selectedOptions) => handleDropdownChange('causesAssociees', selectedOptions)}
                            disabled={readOnly}
                        />
                    </div>
                </div>
                <div className={classes.formGroup}>
                    <div className={classes.labelInput}>
                        <CustomDropdown
                            label="Formulaires"
                            options={formsOptions}
                            selectedOptions={formData.formulaires}
                            setSelectedOptions={(selectedOptions) => handleDropdownChange('formulaires', selectedOptions)}
                            disabled={readOnly}
                        />
                    </div>
                </div>
            </div>
            <div className={classes.buttonContainer}>
                <button className={classes.validerStyle} onClick={handleNext} disabled={readOnly}>Suivant</button>
            </div>
        </div>
    );
};

export default DetailsTab;
